export default __webpack_public_path__ + "static/media/errandService.6b5ae628.png";